import styled from 'styled-components'

import { BrandFlag } from './BrandFlag'

export const BrandFlagSmall = styled(BrandFlag)`
	position: absolute;
	right: 0;
	bottom: 0;
`
